import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "layout"
}
const _hoisted_2 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_RegistrationWarningModal = _resolveComponent("RegistrationWarningModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentHeaderComponent))),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentFooterComponent))),
    _createVNode(_component_RegistrationWarningModal, { ref: "registrationWarningModal" }, null, 512)
  ]))
}